export const ASSETSPATH = {
    ENDSCREEN: "./assets/endTexts/",
    AUDIO: "./assets/audio/",
    GENERIC: "./assets/generic/",
    BUTTONS: "./assets/buttons/",
    FONTS: "./assets/fonts/",
    ANIMATIONS: "./assets/animations/",
    PHYSICS: "./assets/physics/",
    LOAD: "./assets/00load/",
    MENU: "./assets/main_game/0Start/",
    BIRTH: "./assets/main_game/1Birth/",
    TALK: "./assets/main_game/3talk/",
    SCHOOL: "./assets/main_game/4school/",
    PUBERTY: "./assets/main_game/5puberty/",
    FINDHER: "./assets/main_game/6findher/",
    BEERPONG: "./assets/main_game/7beerpong/",
    COFFEE: "./assets/main_game/8coffee/",
    MARRIAGE: "./assets/main_game/9marriage/",
    KIDS: "./assets/main_game/10kids/",
    MIDLIFE: "./assets/main_game/11midlife/",
    GRANDCHILDREN: "./assets/main_game/12grandchildren/",
    PILLS: "./assets/main_game/13pills/",
    DIE: "./assets/main_game/14die/",
    HOME_BUTTON: "./assets/buttons/home/",

    //ARCADE MINIGAMES
    ARCADE_SCREEN: "./assets/_arcade/arcade_menu/",
    INSTRUMENT: "./assets/_arcade/instrument/",
    GRID_FILL: "./assets/_arcade/grid_fill/",
    DISTRACTION: "./assets/_arcade/distraction/",
    BURGER: "./assets/_arcade/burger/",
}

export const CONST = {
    REGISTRY: {
        ADBLOCKENABLED: "adblockEnabled",
        SKIPUSED: "skipUsed",
    },

    GAMESTATE: {
        START: "START",
        PLAYING: "PLAYING",
        WIN: "WIN",
        LOSE: "LOSE",
        LOADNEXTLEVEL: "LOAD",
    },

    TAGS: {
        ARCADE: "ARCADE_TAG",
    },

    SCENES: {
        LOAD: "LOAD",
        PROGRESSIVE_LOAD: "PROGRESSIVE_LOAD",
        SOUNDTRACK: "SOUNDTRACK",
        MENU: "MENU",
        BIRTH: "BIRTH",
        TALK: "TALK",
        SCHOOL: "SCHOOL",
        PUBERTY: "PUBERTY",
        FINDHER: "FINDHER",
        BEERPONG: "BEERPONG",
        COFFEE: "COFFEE",
        MARRIAGE: "MARRIAGE",
        KIDS: "KIDS",
        MIDLIFE: "MIDLIFE",
        GRANDCHILDREN: "GRANDCHILDREN",
        PILLS: "PILLS",
        DIE: "DIE",
        CREDITS: "CREDITS",

        //Arcade minigames
        ARCADE: "ARCADE_SCREEN",
        ARCADE_MINIGAME_LOADING: "ARCADE_MINIGAME_LOADING",
        INSTRUMENT: "INSTRUMENT",
        GRID_FILL: "GRID_FILL",
        DISTRACTION: "DISTRACTION",
        BURGER: "BURGER",
    },

    STORAGE_KEYS: {
        PROGRESS: "game_progress",
    },

    AUDIO: {
        SOUNDTRACK: ASSETSPATH.AUDIO + "soundtrack.mp3",
        SOUNDTRACK_SHORT: ASSETSPATH.AUDIO + "soundtrackShort.mp3",
        GRAB: ASSETSPATH.AUDIO + "paperGrab.mp3",
        POP: ASSETSPATH.AUDIO + "pop.mp3",
        TALK: ASSETSPATH.AUDIO + "talking.mp3",
        CRY: ASSETSPATH.AUDIO + "babyCry.mp3",
        BOUNCE: ASSETSPATH.AUDIO + "bounce.mp3",
        DIESONG: ASSETSPATH.AUDIO + "funeralsong.mp3",
        LIGHTNING: ASSETSPATH.AUDIO + "lightningStrike.mp3",
        NOOO: ASSETSPATH.AUDIO + "noooo.mp3",

        INSTRUMENT_1: ASSETSPATH.AUDIO + "instrument/1.mp3",
        INSTRUMENT_2: ASSETSPATH.AUDIO + "instrument/2.mp3",
        INSTRUMENT_3: ASSETSPATH.AUDIO + "instrument/3.mp3",
        INSTRUMENT_4: ASSETSPATH.AUDIO + "instrument/4.mp3",
        INSTRUMENT_5: ASSETSPATH.AUDIO + "instrument/5.mp3",
        INSTRUMENT_6: ASSETSPATH.AUDIO + "instrument/6.mp3",
        INSTRUMENT_7: ASSETSPATH.AUDIO + "instrument/7.mp3",


        //ARCADE
        FLASH: ASSETSPATH.AUDIO + "arcade/flash.mp3",
        HELLO: ASSETSPATH.AUDIO + "arcade/hello.mp3",
        INSTRUMENT_FAIL: ASSETSPATH.AUDIO + "arcade/instrument-fail.mp3",
        LOSE: ASSETSPATH.AUDIO + "arcade/lose.mp3",
        PING_1: ASSETSPATH.AUDIO + "arcade/ping-1.mp3",
        PING_2: ASSETSPATH.AUDIO + "arcade/ping-2.mp3",
        TRASH: ASSETSPATH.AUDIO + "arcade/trash.mp3",
        TV_OFF: ASSETSPATH.AUDIO + "arcade/tv-turn-off.mp3",
        TV_ON: ASSETSPATH.AUDIO + "arcade/tv-turn-on.mp3",
        VIBRATE: ASSETSPATH.AUDIO + "arcade/vibrate.mp3",
        WIN: ASSETSPATH.AUDIO + "arcade/win.mp3",
    },

    GENERIC: {
        TUTORIAL_HAND: ASSETSPATH.GENERIC + "tutorialHand.png",
    },

    BUTTONS: {
        TRYAGAIN: ASSETSPATH.BUTTONS + "try_again.png",
        SKIP: ASSETSPATH.BUTTONS + "skip.png",
        SPINNER: ASSETSPATH.BUTTONS + "spinner.png",

        ORANGE: ASSETSPATH.BUTTONS + "orange.png",
        PURPLE: ASSETSPATH.BUTTONS + "purple.png",
        RED: ASSETSPATH.BUTTONS + "red.png",
        

        BACK: ASSETSPATH.BUTTONS + "back.png",

        SOUND_ON: ASSETSPATH.BUTTONS + "sound-on.png",
        SOUND_OFF: ASSETSPATH.BUTTONS + "sound-off.png",
    },

    FONT: {
        ATLAS: ASSETSPATH.FONTS + "blogger.png",
        XML: ASSETSPATH.FONTS + "blogger.xml",
    },

    //Old animations from unity. Check if you can maybe replace them with tweens (save around 100kb, probably not worth it)
    ANIMATIONS: {
        SCHOOLEND: ASSETSPATH.ANIMATIONS + "schoolEnd.json",
        PUBERTYEND: ASSETSPATH.ANIMATIONS + "pubertyEnd.json",
        COFFEEEND: ASSETSPATH.ANIMATIONS + "coffeeEnd.json",
        FINDHEREND: ASSETSPATH.ANIMATIONS + "findherEnd.json",
        MARRIAGEFROWN: ASSETSPATH.ANIMATIONS + "marriageFrown.json",
        MARRIAGEWIN: ASSETSPATH.ANIMATIONS + "marriageWin.json",
        DADHEAD: ASSETSPATH.ANIMATIONS + "daddyHead.json",
        KIDSSHOOTBABY: ASSETSPATH.ANIMATIONS + "kidsShootBaby.json",
        MIDLIFELEFTFOOT: ASSETSPATH.ANIMATIONS + "midlifeLeftFoot.json",
        MIDLIFERIGHTFOOT: ASSETSPATH.ANIMATIONS + "midlifeRightFoot.json",
        MIDLIFEWIN: ASSETSPATH.ANIMATIONS + "midlifeWin.json",
        GRANDPAMOVE: ASSETSPATH.ANIMATIONS + "grandpaMove.json",
        GRANDPALEFTHAND: ASSETSPATH.ANIMATIONS + "grandpaLeftHand.json",
        GRANDPARIGHTHAND: ASSETSPATH.ANIMATIONS + "grandpaRightHand.json",
        KIDTORSO: ASSETSPATH.ANIMATIONS + "kidTorso.json",
        KIDLEFTLEG: ASSETSPATH.ANIMATIONS + "kidLeftLeg.json",
        KIDRIGHTLEG: ASSETSPATH.ANIMATIONS + "kidRightLeg.json",
        KIDDIEFIRE: ASSETSPATH.ANIMATIONS + "dieFire.json",
        KIDDIEELECTRIC: ASSETSPATH.ANIMATIONS + "dieElectric.json",
        PILLSEND: ASSETSPATH.ANIMATIONS + "pillsEnd.json"
    },

    PHYSICS: {
        PILLS: ASSETSPATH.PHYSICS + "PillsShapes.json",
        BEERPONG: ASSETSPATH.PHYSICS + "beerpongShapes.json",
    },

    MENU: {
        BACKGROUND: ASSETSPATH.MENU + "background.png",
        CLOUDS: ASSETSPATH.MENU + "clouds.png",
        NATURE: ASSETSPATH.MENU + "nature.png",
        TITLE_TEXT: ASSETSPATH.MENU + "title_text.png",
        CHARACTER: ASSETSPATH.MENU + "character.png",
    },

    HOME_BUTTON: {
        BACKGROUND: ASSETSPATH.HOME_BUTTON + "bg.png",
        CHECK: ASSETSPATH.HOME_BUTTON + "check.png",
        CHECK_HIGHLIGHT: ASSETSPATH.HOME_BUTTON + "check_highlight.png",
        X: ASSETSPATH.HOME_BUTTON + "x.png",
        X_HIGHLIGHT: ASSETSPATH.HOME_BUTTON + "x_highlight.png",
        HIGHLIGHT: ASSETSPATH.HOME_BUTTON + "highlight.png",
        NORMAL: ASSETSPATH.HOME_BUTTON + "normal.png",
    },

    BIRTH: {
        BACKGROUND: ASSETSPATH.BIRTH + "background.png",
        BABY: ASSETSPATH.BIRTH + "baby.png",
        CLICKER: ASSETSPATH.BIRTH + "clicker.png",
        MAMICA1: ASSETSPATH.BIRTH + "mamica-1.png",
        MAMICA2: ASSETSPATH.BIRTH + "mamica-2.png",
        MAMICA3: ASSETSPATH.BIRTH + "mamica-3.png",
        MAMICA4: ASSETSPATH.BIRTH + "mamica-4.png",
        MAMICA5: ASSETSPATH.BIRTH + "mamica-5.png",
        PUSH: ASSETSPATH.BIRTH + "push.png",
        STROLLER: ASSETSPATH.BIRTH + "stroler.png",
        SWING: ASSETSPATH.BIRTH + "swing.png",        
        END: ASSETSPATH.ENDSCREEN + "birth.png"
    },

    TALK: {
        STARTBACKGROUND: ASSETSPATH.TALK + "startBackground.png",
        ENDSTRETCH: ASSETSPATH.TALK + "end-stretch.png",
        ENDBACKGROUND: ASSETSPATH.TALK + "end.png",
        NOTE_1: ASSETSPATH.TALK + "note-1.png",
        NOTE_2: ASSETSPATH.TALK + "note-2.png",
        NOTE_3: ASSETSPATH.TALK + "note-3.png",
        NOTE_4: ASSETSPATH.TALK + "note-4.png",
        STRETCHBACKGROUND: ASSETSPATH.TALK + "stretch.png",
        TAP: ASSETSPATH.TALK + "tap.png",
        SMILE: ASSETSPATH.TALK + "smile.png",
        END: ASSETSPATH.ENDSCREEN + "talk.png"
    },

    SCHOOL: {
        BACKGROUND: ASSETSPATH.SCHOOL + "background.png",
        BOY: ASSETSPATH.SCHOOL + "boy.png",
        NOTE_3: ASSETSPATH.SCHOOL + "3.png",
        NOTE_4: ASSETSPATH.SCHOOL + "4.png",
        NOTE_17: ASSETSPATH.SCHOOL + "17.png",
        NOTE_20: ASSETSPATH.SCHOOL + "20.png",
        NOTE_27: ASSETSPATH.SCHOOL + "27.png",
        NOTE_H2NO: ASSETSPATH.SCHOOL + "h2no.png",
        NOTE_YES: ASSETSPATH.SCHOOL + "yes.png",
        WINIMAGE: ASSETSPATH.SCHOOL + "a-plus.png",
        LOSEIMAGE: ASSETSPATH.SCHOOL + "f-minus.png",
        END: ASSETSPATH.ENDSCREEN + "school.png"
    },

    PUBERTY: {
        BACKGROUND: ASSETSPATH.PUBERTY + "background-and-boy.png",
        BRACES: ASSETSPATH.PUBERTY + "braces.png",
        PARTICLE: ASSETSPATH.PUBERTY + "drop.png",
        PIMPLE: ASSETSPATH.PUBERTY + "little-pimple.png",
        POP_TEXT: ASSETSPATH.PUBERTY + "pop.png",
        END: ASSETSPATH.ENDSCREEN + "puberty.png"
    },

    FINDHER: {
        FOREGROUND: ASSETSPATH.FINDHER + "findher.png",
        WHITEBACKGROUND: ASSETSPATH.FINDHER + "white.png",
        SWIPETEXT: ASSETSPATH.FINDHER + "swipe.png",
        LIKE_OVERLAY: ASSETSPATH.FINDHER + "LIKE.png",
        NOPE_OVERLAY: ASSETSPATH.FINDHER + "NOPE.png",
        CUTIE_1: ASSETSPATH.FINDHER + "cutie-1.png",
        CUTIE_2: ASSETSPATH.FINDHER + "cutie-2.png",
        CUTIE_3: ASSETSPATH.FINDHER + "cutie-3.png",
        NOTCUTE_1: ASSETSPATH.FINDHER + "not-so-cute-1.png",
        NOTCUTE_2: ASSETSPATH.FINDHER + "not-so-cute-2.png",
        ZOIDBERG: ASSETSPATH.FINDHER + "zoidberg.png",
        WINIMAGE: ASSETSPATH.FINDHER + "its-a-match.png",
        WRONG_1: ASSETSPATH.FINDHER + "tindher-wrong.png",
        WRONG_2: ASSETSPATH.FINDHER + "wrong-2-tindher.png",
        WRONG_3: ASSETSPATH.FINDHER + "tindher-wrong-3.png",
        WRONG_4: ASSETSPATH.FINDHER + "tindher-wrong-4.png"

    },

   BEERPONG: {
        BACKGROUND: ASSETSPATH.BEERPONG + "background.png",
        DUNKTEXT: ASSETSPATH.BEERPONG + "dunk-it.png",
        CUP_FRONT: ASSETSPATH.BEERPONG + "FRONT.png",
        CUP_BACK: ASSETSPATH.BEERPONG + "BACK.png",
        BALL: ASSETSPATH.BEERPONG + "ball.png",
        BLACK_CIRCLE: ASSETSPATH.BEERPONG + "blackCircle.png",
        END: ASSETSPATH.ENDSCREEN + "beerpong.png"
    },

    COFFEE: {
        BACKGROUND: ASSETSPATH.COFFEE + "background.png",
        MAKECOFFEETEXT: ASSETSPATH.COFFEE + "make-coffee.png",
        CUP_CHEESE: ASSETSPATH.COFFEE + "cheese-cup.png",
        NORMAL_CHEESE: ASSETSPATH.COFFEE + "cheese-normal.png",
        CUP_COFFEE: ASSETSPATH.COFFEE + "coffee-cup.png",
        NORMAL_COFFEE: ASSETSPATH.COFFEE + "coffee.png",
        CUP_EGG: ASSETSPATH.COFFEE + "egg-cup.png",
        NORMAL_EGG: ASSETSPATH.COFFEE + "egg.png",
        CUP_MILK: ASSETSPATH.COFFEE + "milk-cup.png",
        NORMAL_MILK: ASSETSPATH.COFFEE + "milk.png",
        CUP_PEPPER: ASSETSPATH.COFFEE + "pepper-cup.png",
        NORMAL_PEPPER: ASSETSPATH.COFFEE + "pepper.png",
        CUP_SALT: ASSETSPATH.COFFEE + "salt-cup.png",
        NORMAL_SALT: ASSETSPATH.COFFEE + "salt.png",
        CUP_SCREW: ASSETSPATH.COFFEE + "screw-cup.png",
        NORMAL_SCREW: ASSETSPATH.COFFEE + "screw.png",
        CUP_SUGAR: ASSETSPATH.COFFEE + "sugar-cup.png",
        NORMAL_SUGAR: ASSETSPATH.COFFEE + "sugar.png",
        CUP_TOMATO: ASSETSPATH.COFFEE + "tomato-cup.png",
        NORMAL_TOMATO: ASSETSPATH.COFFEE + "tomato.png",
        WINIMAGE: ASSETSPATH.COFFEE + "coffee-right-01.png",
        LOSEIMAGE: ASSETSPATH.COFFEE + "coffee-wrong-boss.png",
        END: ASSETSPATH.ENDSCREEN + "coffee.png"
    },

    MARRIAGE: {
        BACKGROUND: ASSETSPATH.MARRIAGE + "background.png",
        BACKGROUND_OVERLAY: ASSETSPATH.MARRIAGE + "suit-up-2.png",
        HANDS: ASSETSPATH.MARRIAGE + "hands.png",
        PANTS_1: ASSETSPATH.MARRIAGE + "pants-1.png",
        PANTS_2: ASSETSPATH.MARRIAGE + "pants-2.png",
        PANTS_3: ASSETSPATH.MARRIAGE + "pants-3.png",
        PANTS_4: ASSETSPATH.MARRIAGE + "pants-4.png",
        PANTS_5: ASSETSPATH.MARRIAGE + "pants-5.png",
        SHIRT_1: ASSETSPATH.MARRIAGE + "shirt-1-no-sleve.png",
        SHIRT_2: ASSETSPATH.MARRIAGE + "shirt-2.png",
        SHIRT_3: ASSETSPATH.MARRIAGE + "shirt-3.png",
        SHIRT_4: ASSETSPATH.MARRIAGE + "shirt-4.png",
        SHIRT_5: ASSETSPATH.MARRIAGE + "shirt-5.png",
        SHOES_1: ASSETSPATH.MARRIAGE + "shoes-1.png",
        SHOES_2: ASSETSPATH.MARRIAGE + "shoes-2.png",
        SHOES_3: ASSETSPATH.MARRIAGE + "shoes-3.png",
        SLEEVE: ASSETSPATH.MARRIAGE + "sleve.png",
        WINIMAGE: ASSETSPATH.MARRIAGE + "married.png",
        END: ASSETSPATH.ENDSCREEN + "marriage.png",
    },

    KIDS: {
        BABY_2: ASSETSPATH.KIDS + "baby-2.png",
        BABY_3: ASSETSPATH.KIDS + "baby-3.png",
        BABY_4: ASSETSPATH.KIDS + "baby-4.png",
        MAMICA1: ASSETSPATH.KIDS + "birth.png",
        MAMICA2: ASSETSPATH.KIDS + "birth-2.png",
        MAMICA3: ASSETSPATH.KIDS + "birth-3.png",
        MAMICA4: ASSETSPATH.KIDS + "birth-4.png",
        MAMICA5: ASSETSPATH.KIDS + "birth-5.png",
        DADBOD: ASSETSPATH.KIDS + "body.png",
        DADHEAD: ASSETSPATH.KIDS + "head.png",
        TEXT_1: ASSETSPATH.KIDS + "TEXT-1.png",
        TEXT_2: ASSETSPATH.KIDS + "TEXT-2.png",
        TEXT_3: ASSETSPATH.KIDS + "TEXT-3.png",
        TEXT_4: ASSETSPATH.KIDS + "TEXT-4.png",
        TEXT_5: ASSETSPATH.KIDS + "TEXT-5.png",
        END: ASSETSPATH.ENDSCREEN + "kids.png"
    },

    MIDLIFE: {
        BACKGROUND: ASSETSPATH.MIDLIFE + "background.png",
        ENDLESSBACKGROUND: ASSETSPATH.MIDLIFE + "endless.png",
        PICKTEXT: ASSETSPATH.MIDLIFE + "pick-drop.png",
        BODY: ASSETSPATH.MIDLIFE + "body.png",
        FEET: ASSETSPATH.MIDLIFE + "feet-one.png",
        HEAD: ASSETSPATH.MIDLIFE + "head.png",
        LIST: ASSETSPATH.MIDLIFE + "list.png",

        BEER: ASSETSPATH.MIDLIFE + "beer.png",
        CANDY: ASSETSPATH.MIDLIFE + "candy.png",
        CAR: ASSETSPATH.MIDLIFE + "car.png",
        CD: ASSETSPATH.MIDLIFE + "cd.png",
        PANTIES: ASSETSPATH.MIDLIFE + "panties.png",
        TICKET: ASSETSPATH.MIDLIFE + "ticket.png",
        WEIGHTS: ASSETSPATH.MIDLIFE + "weights.png",

        WINIMAGE: ASSETSPATH.MIDLIFE + "midlife-happy.png",
        ENDEVERYTHING: ASSETSPATH.MIDLIFE + "endEverything.png",
        END: ASSETSPATH.MIDLIFE + "end.png",
    },

    GRANDCHILDREN: {
        BACKGROUND: ASSETSPATH.GRANDCHILDREN + "background.png",
        DRAGTEXT: ASSETSPATH.GRANDCHILDREN + "drag-drop-2.png",
        //FEET: ASSETSPATH.GRANDCHILDREN + "feet-one.png",
        HANDS_LEFT: ASSETSPATH.GRANDCHILDREN + "hands-left.png",
        HANDS_RIGHT: ASSETSPATH.GRANDCHILDREN + "hands-right.png",
        GRANDPA: ASSETSPATH.GRANDCHILDREN + "grandpa.png",
        KID1: ASSETSPATH.GRANDCHILDREN + "kid-1.png",
        KID2: ASSETSPATH.GRANDCHILDREN + "kid-2.png",
        KID3: ASSETSPATH.GRANDCHILDREN + "kid-3.png",
        END: ASSETSPATH.ENDSCREEN + "grandchildren.png"
    },

    PILLS: {
        BACKGROUND: ASSETSPATH.PILLS + "background.png",
        BOX1: ASSETSPATH.PILLS + "box.png",
        BOX2: ASSETSPATH.PILLS + "box-2.png",
        BOX3: ASSETSPATH.PILLS + "box-3.png",
        BIGBOX: ASSETSPATH.PILLS + "big-box.png",
        PILL1: ASSETSPATH.PILLS + "pill-1.png",
        PILL2: ASSETSPATH.PILLS + "pill-2.png",
        PILL3: ASSETSPATH.PILLS + "pill-3.png",
        GRANDPA: ASSETSPATH.PILLS + "grandpa.png",
        SORTTEXT: ASSETSPATH.PILLS + "sort.png",
        TABLE: ASSETSPATH.PILLS + "table.png",
        END: ASSETSPATH.ENDSCREEN + "pills.png"
    },

    DIE: {
        BACKGROUND: ASSETSPATH.DIE + "Death.png",
        END: ASSETSPATH.DIE + "end.png"
    },

    CREDITS: {
        END: ASSETSPATH.ENDSCREEN + "credits.png"
    },

    //Arcade minigames

    ARCADE_SCREEN: {
        BACKGROUND: ASSETSPATH.ARCADE_SCREEN + "background.png",
        DARK_LAYER: ASSETSPATH.ARCADE_SCREEN + "dark.png",
        HOME_BUTTON: ASSETSPATH.ARCADE_SCREEN + "home.png",
        NEW: ASSETSPATH.ARCADE_SCREEN + "new.png",
        
        BURGER: ASSETSPATH.ARCADE_SCREEN + "burger.png",
        BURGER_SELECTED: ASSETSPATH.ARCADE_SCREEN + "burger_selected.png",

        INSTRUMENT: ASSETSPATH.ARCADE_SCREEN + "instrument.png",
        INSTRUMENT_SELECTED: ASSETSPATH.ARCADE_SCREEN + "instrument_selected.png",
        
        GRIDFILL: ASSETSPATH.ARCADE_SCREEN + "gridfill.png",
        GRIDFILL_SELECTED: ASSETSPATH.ARCADE_SCREEN + "gridfill_selected.png",
        
        DISTRACTION: ASSETSPATH.ARCADE_SCREEN + "distraction.png",
        DISTRACTION_SELECTED: ASSETSPATH.ARCADE_SCREEN + "distraction_selected.png",
        
        MAIN_GAME: ASSETSPATH.ARCADE_SCREEN + "main_game.png",
        MAIN_GAME_SELECTED: ASSETSPATH.ARCADE_SCREEN + "main_game_selected.png",
        NEW_LEVELS: ASSETSPATH.ARCADE_SCREEN + "new_levels.png",
    },

    INSTRUMENT: {
        BACKGROUND: ASSETSPATH.INSTRUMENT + "bg.png",

        CHARACTER_BODY: ASSETSPATH.INSTRUMENT + "char.png",
        CHARACTER_HEAD: ASSETSPATH.INSTRUMENT + "char-head.png",
        HAND_LEFT: ASSETSPATH.INSTRUMENT + "handLeft.png",
        HAND_RIGHT_TOP: ASSETSPATH.INSTRUMENT + "handRightTop.png",
        HAND_RIGHT_BOTTOM: ASSETSPATH.INSTRUMENT + "handRightBottom.png",
        TABLE: ASSETSPATH.INSTRUMENT + "table.png",

        HEART: ASSETSPATH.INSTRUMENT + "heart_full.png",
        HEART_EMPTY: ASSETSPATH.INSTRUMENT + "heart_empty.png",

        BAR_WHITE_1: ASSETSPATH.INSTRUMENT + "white/1.png",
        BAR_WHITE_2: ASSETSPATH.INSTRUMENT + "white/2.png",
        BAR_WHITE_3: ASSETSPATH.INSTRUMENT + "white/3.png",
        BAR_WHITE_4: ASSETSPATH.INSTRUMENT + "white/4.png",
        BAR_WHITE_5: ASSETSPATH.INSTRUMENT + "white/5.png",
        BAR_WHITE_6: ASSETSPATH.INSTRUMENT + "white/6.png",
        BAR_WHITE_7: ASSETSPATH.INSTRUMENT + "white/7.png",

        BAR_DARK_1: ASSETSPATH.INSTRUMENT + "dark/1.png",
        BAR_DARK_2: ASSETSPATH.INSTRUMENT + "dark/2.png",
        BAR_DARK_3: ASSETSPATH.INSTRUMENT + "dark/3.png",
        BAR_DARK_4: ASSETSPATH.INSTRUMENT + "dark/4.png",
        BAR_DARK_5: ASSETSPATH.INSTRUMENT + "dark/5.png",
        BAR_DARK_6: ASSETSPATH.INSTRUMENT + "dark/6.png",
        BAR_DARK_7: ASSETSPATH.INSTRUMENT + "dark/7.png",

        //ENDSCREEN
        END: ASSETSPATH.INSTRUMENT + "end/end.png",
        BACK: ASSETSPATH.INSTRUMENT + "end/back.png",
        BACK_2: ASSETSPATH.INSTRUMENT + "end/back_2.png",
        CONTINUE: ASSETSPATH.INSTRUMENT + "end/continue.png",
        TRY_AGAIN: ASSETSPATH.INSTRUMENT + "end/try_again.png",
        TRY_AGAIN_2: ASSETSPATH.INSTRUMENT + "end/try_again_2.png",
        NEW_BEST: ASSETSPATH.INSTRUMENT + "end/new-best.png",

    },

    GRID_FILL: {
        BACKGROUND: ASSETSPATH.GRID_FILL + "background.png",
        HANDS: ASSETSPATH.GRID_FILL + "hands.png",
        CAMERA: ASSETSPATH.GRID_FILL + "camera.png",
        SCREEN: ASSETSPATH.GRID_FILL + "screen.png",

        BLOCK_BLUE: ASSETSPATH.GRID_FILL + "blue.png",
        BLOCK_GREEN: ASSETSPATH.GRID_FILL + "green.png",
        BLOCK_ORANGE: ASSETSPATH.GRID_FILL + "orange.png",
        BLOCK_PURPLE: ASSETSPATH.GRID_FILL + "purple.png",
        BLOCK_RED: ASSETSPATH.GRID_FILL + "red.png",
        BLOCK_YELLOW: ASSETSPATH.GRID_FILL + "yellow.png",
        BLOCK_GREY: ASSETSPATH.GRID_FILL + "grey.png",

        //end screen
        END: ASSETSPATH.GRID_FILL + "end_screen/end.png",
        BACK: ASSETSPATH.GRID_FILL + "end_screen/back.png",
        CONTINUE: ASSETSPATH.GRID_FILL + "end_screen/continue.png",
        NEW_BEST: ASSETSPATH.GRID_FILL + "end_screen/new_best.png",
        TRY_AGAIN: ASSETSPATH.GRID_FILL + "end_screen/try_again.png",
        TRY_AGAIN_2: ASSETSPATH.GRID_FILL + "end_screen/try_again_2.png",
        ARCADE: ASSETSPATH.GRID_FILL + "end_screen/arcade.png",

        //Countdown
        COUNTDOWN_1: ASSETSPATH.GRID_FILL + "countdown/slider1.png",
        COUNTDOWN_2: ASSETSPATH.GRID_FILL + "countdown/slider2.png",
        COUNTDOWN_3: ASSETSPATH.GRID_FILL + "countdown/slider3.png",
    },

    DISTRACTION: {
        BACKGROUND: ASSETSPATH.DISTRACTION + "background.png",
        WINDOW_BACK: ASSETSPATH.DISTRACTION + "window_back.png",
        WINDOW_FRONT: ASSETSPATH.DISTRACTION + "window_front.png",
        CHARACTER: ASSETSPATH.DISTRACTION + "character.png",
        ARM: ASSETSPATH.DISTRACTION + "arm.png",
        HAND: ASSETSPATH.DISTRACTION + "hand.png",
        CLOUD: ASSETSPATH.DISTRACTION + "cloud.png",

        //PHONE
        PHONE: ASSETSPATH.DISTRACTION + "phone/phone.png",
        PHONE_BUZZ_1: ASSETSPATH.DISTRACTION + "phone/phone_buzz_1.png",
        PHONE_BUZZ_2: ASSETSPATH.DISTRACTION + "phone/phone_buzz_2.png",
        PHONE_MESSAGE_1 : ASSETSPATH.DISTRACTION + "phone/phone_message_1.png",
        PHONE_MESSAGE_2: ASSETSPATH.DISTRACTION + "phone/phone_message_2.png",
        PHONE_MESSAGE_3: ASSETSPATH.DISTRACTION + "phone/phone_message_3.png",
        PHONE_SHADOW: ASSETSPATH.DISTRACTION + "phone/phone_shadow.png",

    
        TV_TEXT_0: ASSETSPATH.DISTRACTION + "tv/0.png",
        TV_TEXT_1: ASSETSPATH.DISTRACTION + "tv/1.png",
        TV_TEXT_2: ASSETSPATH.DISTRACTION + "tv/2.png",
        TV_TEXT_3: ASSETSPATH.DISTRACTION + "tv/3.png",
        TV_TEXT_4: ASSETSPATH.DISTRACTION + "tv/4.png",
        TV_PADDLE: ASSETSPATH.DISTRACTION + "tv/rectangle.png",
        TV_BALL: ASSETSPATH.DISTRACTION + "tv/tv-ball.png",
        TV_SCREEN_DARK: ASSETSPATH.DISTRACTION + "tv/dark_screen.png",
        TV_SCREEN_LIGHT: ASSETSPATH.DISTRACTION + "tv/light-screen.png",


        WINDOW_HAND: ASSETSPATH.DISTRACTION + "window/waving-hand.png",
        WINDOW_CHARACTER: ASSETSPATH.DISTRACTION + "window/window_character.png",

        BALL_1 : ASSETSPATH.DISTRACTION + "ball/ball_1.png",
        BALL_2 : ASSETSPATH.DISTRACTION + "ball/ball_2.png",
        BALL_3 : ASSETSPATH.DISTRACTION + "ball/ball_3.png",
        BALL_4 : ASSETSPATH.DISTRACTION + "ball/ball_4.png",
        BALL_5 : ASSETSPATH.DISTRACTION + "ball/ball_5.png",
        BALL_6 : ASSETSPATH.DISTRACTION + "ball/ball_6.png",

        //END
        END: ASSETSPATH.DISTRACTION + "end/end.png",
        BACK: ASSETSPATH.DISTRACTION + "end/back.png",
        BACK_2: ASSETSPATH.DISTRACTION + "end/back_2.png",
        CONTINUE: ASSETSPATH.DISTRACTION + "end/continue.png",
        TRY_AGAIN: ASSETSPATH.DISTRACTION + "end/try_again.png",
        TRY_AGAIN_2: ASSETSPATH.DISTRACTION + "end/try_again_2.png",
        NEW_BEST: ASSETSPATH.DISTRACTION + "end/new-best.png",

          //Countdown
          COUNTDOWN_1: ASSETSPATH.DISTRACTION + "countdown/slider1.png",
          COUNTDOWN_2: ASSETSPATH.DISTRACTION + "countdown/slider2.png",
          COUNTDOWN_3: ASSETSPATH.DISTRACTION + "countdown/slider3.png",
    },

    BURGER: {
        BACKGROUND : ASSETSPATH.BURGER + "background.png",
        ROPE: ASSETSPATH.BURGER + "rope.png",
        BOARD: ASSETSPATH.BURGER + "board.png",
        HAND: ASSETSPATH.BURGER + "hand.png",

        PLATE: ASSETSPATH.BURGER + "plate.png",
        PLATE_OUTLINE: ASSETSPATH.BURGER + "plate_outline.png",
        TRASH: ASSETSPATH.BURGER + "trash.png",
        TRASH_OUTLINE: ASSETSPATH.BURGER + "trash_outline.png",
        TRASH_TOP: ASSETSPATH.BURGER + "trash_top.png",

        TIMER: ASSETSPATH.BURGER + "timer_bg.png",
        TIMER_CIRCLE: ASSETSPATH.BURGER + "circle_white.png",

        PAPER: ASSETSPATH.BURGER + "paper/paper.png",

        //INGREDIENTS
        I_BUN_BOTTOM: ASSETSPATH.BURGER + "ingredients/bun_bottom.png",
        I_BUN_TOP: ASSETSPATH.BURGER + "ingredients/bun_top.png",
        I_CHEESE: ASSETSPATH.BURGER + "ingredients/cheese.png",
        I_EGGS: ASSETSPATH.BURGER + "ingredients/eggs.png",
        I_LETTUCE: ASSETSPATH.BURGER + "ingredients/lettuce.png",
        I_PATTY: ASSETSPATH.BURGER + "ingredients/patty.png",
        I_TOMATO: ASSETSPATH.BURGER + "ingredients/tomato.png",
        
        //INGREDIENTSHADOWS
        I_S_BUN_BOTTOM: ASSETSPATH.BURGER + "ingredients/shadow/bun_bottom.png",
        I_S_BUN_TOP: ASSETSPATH.BURGER + "ingredients/shadow/bun_top.png",
        I_S_CHEESE: ASSETSPATH.BURGER + "ingredients/shadow/cheese.png",
        I_S_EGGS: ASSETSPATH.BURGER + "ingredients/shadow/eggs.png",
        I_S_LETTUCE: ASSETSPATH.BURGER + "ingredients/shadow/lettuce.png",
        I_S_PATTY: ASSETSPATH.BURGER + "ingredients/shadow/patty.png",
        I_S_TOMATO: ASSETSPATH.BURGER + "ingredients/shadow/tomato.png",

         //PAPER SATURATED INGREDIENTS
         P_S_BUN_BOTTOM: ASSETSPATH.BURGER + "paper/saturated/bun_bottom.png",
         P_S_BUN_TOP: ASSETSPATH.BURGER + "paper/saturated/bun_top.png",
         P_S_CHEESE: ASSETSPATH.BURGER + "paper/saturated/cheese.png",
         P_S_EGGS: ASSETSPATH.BURGER + "paper/saturated/egg.png",
         P_S_LETTUCE: ASSETSPATH.BURGER + "paper/saturated/salad.png",
         P_S_PATTY: ASSETSPATH.BURGER + "paper/saturated/patty.png",
         P_S_TOMATO: ASSETSPATH.BURGER + "paper/saturated/tomato.png",

         //END SCREEN
         ARCADE_BUTTON: ASSETSPATH.BURGER + "end/arcade_button.png",
         BACK_TO_ARCADE: ASSETSPATH.BURGER + "end/back_to_arcade.png",
         BURGERS_TEXT: ASSETSPATH.BURGER + "end/burgers_text.png",
         CONTINUE_BUTTON: ASSETSPATH.BURGER + "end/continue_button.png",
         END: ASSETSPATH.BURGER + "end/end_screen.png",
         TRY_AGAIN_BUTTON: ASSETSPATH.BURGER + "end/try_again_button.png",
         TRY_AGAIN_BUTTON_2: ASSETSPATH.BURGER + "end/try_again_button_2.png",
         NEW_BEST: ASSETSPATH.BURGER + "end/new_best.png",
    }
}